/**
 * @fileoverview Agent definition for prose-continuer-guided-neutral.
 *
 * A reduced variant of prose-continuer-guided focused on continuity, pacing,
 * and beats. Outputs deliberately neutral prose intended to be transformed
 * by a downstream stylization pass (e.g., style-aligner-v2).
 *
 * @category narrative.prose.drafting
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

// =============================================================================
// AGENT DEFINITION
// =============================================================================

export const definition: AppAgentDefinition = {
  id: 'prose-continuer-guided-neutral',
  kind: 'primitive',
  name: 'Continue (Guided, Neutral)',
  description: 'Continues the story within the planned chapter structure in deliberately neutral prose. Focuses on continuity, pacing, and beats; intended to be paired with a downstream stylization pass.',
  category: 'writing',
  defaultPrompt: prompt,
  systemPrompt: `You are a narrative architect continuing fiction prose within a defined chapter plan. You prioritize continuity, pacing, and beats over style. You write in plain, workmanlike prose; a downstream stylization pass will apply voice and tone.`,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,

  // --- Metadata (Hybrid Architecture) ---
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-05',
    lastUpdated: '2026-05',
    taxonomyPath: 'narrative.prose.drafting',
    usedBy: [],
    usedInComposites: [],
    relatedAgents: [
      'prose-continuer-guided',
      'prose-continuer-discovery-neutral',
      'chapter-drafter-v2-neutral',
      'style-aligner-v2',
    ],
  },
};
